module.exports = __webpack_public_path__ + "static/media/imgop_iocLogo.808adef8.jp2";